import type { AutomaticLabel } from "../api/types";

const CATEGORY_NAMES: Record<string, string> = {
  control: "遥控与执行",
  interaction: "接触与交互",
  phase: "任务阶段",
  task: "任务语义",
  recording: "录制状态",
  safety: "安全事件",
  quality: "数据质量",
  review: "训练审核",
};

export function AutomaticLabelsPanel({ labels }: { labels: AutomaticLabel[] }) {
  const origin = labels.length ? BigInt(labels[0].start_time_ns) : 0n;
  return (
    <section className="automatic-labels card">
      <div className="section-title">
        <div><p className="eyebrow">采集侧事实</p><h2>自动导入标签</h2></div>
        <span>{labels.length} 条</span>
      </div>
      {!labels.length ? <p className="empty-note">本次录制没有自动标签。</p> : (
        <div className="automatic-label-list">
          {labels.map((label) => (
            <article className="automatic-label-row" key={label.id}>
              <div><strong>{label.display_name}</strong><code>{label.label_key}</code></div>
              <span>{CATEGORY_NAMES[label.category] ?? label.category}</span>
              <span>{formatInterval(label, origin)}</span>
              <span>{formatAttributes(label.attributes)}</span>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}

function formatInterval(label: AutomaticLabel, origin: bigint): string {
  const start = Number(BigInt(label.start_time_ns) - origin) / 1e9;
  const end = Number(BigInt(label.end_time_ns) - origin) / 1e9;
  if (label.scope !== "range" || start === end) return `+${start.toFixed(3)} 秒`;
  return `+${start.toFixed(3)} 至 +${end.toFixed(3)} 秒`;
}

function formatAttributes(attributes: Record<string, unknown>): string {
  const entries = Object.entries(attributes).filter(([, value]) => value !== null && value !== "");
  if (!entries.length) return "无附加属性";
  return entries.slice(0, 3).map(([key, value]) => `${key}=${String(value)}`).join(" · ");
}
